import { defineComponent as h, resolveComponent as r, openBlock as i, createElementBlock as l, createBlock as f, withCtx as g, createElementVNode as m, createVNode as s, Fragment as b, renderList as S, createCommentVNode as V } from "vue";
import k from "../VFormRadioCheckbox/VFormRadioCheckbox.js";
import _ from "../../atoms/VFormRadioCheckboxGroup/VFormRadioCheckboxGroup.js";
import { _ as w } from "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import { V as v } from "../../../VState-9b477ed6.js";
import { _ as y } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../vee-validate.esm-c4518011.js";
import "../../../constants-69d32a0e.js";
import "../../../composables/useSpacingClass.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../atoms/VButton/VButton.js";
import "../../atoms/VIcon/VIcon.js";
import "../../atoms/VSpinner/VSpinner.js";
import "../../atoms/VHTMLText/VHTMLText.js";
import "../../../utils/htmlSanitizer.js";
import "../../atoms/VLink/VLink.js";
import "../../../utils/isExternalUrl.js";
import "../../atoms/VSubtitle/VSubtitle.js";
import "../../../utils/tailwindUnitsConverter.js";
import "../../../Spacing-695d3b19.js";
import "../../../VImage-b57fd9d1.js";
const T = h({
  name: "VFormTimeslotPicker",
  components: {
    VFormRadioCheckboxGroup: _,
    VFormRadioCheckbox: k,
    VHeadline: w,
    VState: v
  },
  emits: ["time-slot-picker:change"],
  props: {
    name: {
      type: String,
      required: !0
    },
    dateWithSlots: {
      type: Object,
      default: null
    },
    label: {
      type: String
    },
    noTimeSlotTitle: { type: String, default: "Kein Termin verfügbar" },
    noTimeSlotDescription: {
      type: String,
      default: "Es sind leider keine Termine verfügbar. Bitte wähle einen anderen Tag aus."
    },
    timeslotValue: {
      type: String,
      default: ""
    },
    validationRules: {
      type: Function,
      default: () => "some string"
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  computed: {
    showNoSlots() {
      var e, t;
      return this.dateWithSlots && !((t = (e = this.dateWithSlots) == null ? void 0 : e.timeSlots) != null && t.length);
    }
  },
  inheritAttrs: !1,
  methods: {
    onChange(e, t) {
      e.target.summary = t, this.$emit("time-slot-picker:change", e);
    }
  },
  watch: {
    showNoSlots(e) {
      e && window.dispatchEvent(
        new CustomEvent("time-slot-picker:no-time-slots-error")
      );
    }
  }
});
const C = { class: "hobi-time-slot-picker" }, F = { class: "hobi-time-slot-picker-wrapper tw-flex tw-flex-col tw-px-1 tw-w-full" }, R = {
  key: 1,
  class: "hobi-time-slot-picker-no-slots tw-pt-12"
}, W = { class: "hide-checkbox tw-hidden" };
function $(e, t, E, N, B, G) {
  var a;
  const d = r("VHeadline"), n = r("VFormRadioCheckbox"), p = r("VFormRadioCheckboxGroup"), u = r("VState");
  return i(), l("div", C, [
    e.dateWithSlots && ((a = e.dateWithSlots.timeSlots) != null && a.length) ? (i(), f(p, {
      key: 0,
      fieldName: `${e.name}Group`,
      "bottom-spacing": "xs"
    }, {
      default: g(() => [
        m("div", F, [
          s(d, {
            title: e.label,
            size: "xxs",
            "top-spacing": "xs",
            "bottom-spacing": "m"
          }, null, 8, ["title"]),
          (i(!0), l(b, null, S(e.dateWithSlots.timeSlots, (o) => (i(), l("div", {
            class: "hobi-time-slot-picker-item tw-py-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-300",
            key: e.name + o.time + e.dateWithSlots.iso
          }, [
            s(n, {
              id: `${o.id}`,
              name: e.name,
              label: o.time,
              value: o.iso,
              modelValue: e.timeslotValue,
              rules: e.validationRules,
              highlightError: !1,
              onChange: (c) => e.onChange(c, o.formattedDateTime)
            }, null, 8, ["id", "name", "label", "value", "modelValue", "rules", "onChange"])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["fieldName"])) : e.dateWithSlots && !e.dateWithSlots.timeSlots.length ? (i(), l("div", R, [
      s(u, {
        title: e.noTimeSlotTitle,
        message: e.noTimeSlotDescription,
        iconType: "illustration-error-appointment",
        router: e.router,
        iconViewBox: "0 0 88 88"
      }, null, 8, ["title", "message", "router"]),
      m("div", W, [
        s(n, {
          id: "emptyTimeSlot",
          name: "emptyTimeSlot",
          value: "s",
          modelValue: "",
          rules: e.validationRules,
          highlightError: !1
        }, null, 8, ["rules"])
      ])
    ])) : V("", !0)
  ]);
}
const oe = /* @__PURE__ */ y(T, [["render", $], ["__scopeId", "data-v-50a95872"]]);
export {
  oe as default
};
